import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

function SearchBar({ searchQuery, setSearchQuery }) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Search events by title or description..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearchQuery("")} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      sx={{ mb: 2, backgroundColor: "#fff", borderRadius: 1 }}
    />
  );
}

export default SearchBar;
